module.exports = __webpack_public_path__ + "img/avatar3.c0e76014.png";